import { mapState } from 'vuex';
export default {
    components:{
    },
    props: {
        currLayoutData: {
            type: Object,
            default: {}
        },
        layoutIndex:{
            type:[Number,String],
            default:0,
        },
    },
    data() {
        return {
        }
    },
    computed:{
        ...mapState(['isShowInvalidSeat','contextMenuRef','high_person_id','meetingInfo'])
    },
    filters: {
        setSelectionElRef(person) {
            return person ? `person-id-${person.person_id}` : '';
        }
    },
    methods: {

        // 超出父级区域后增加滚动类名
        isMaxParentArea(text){
            text = text.replace(/\s+/g, '');
            // 如果是中文
            if(/^[\u4e00-\u9fa5\d]+$/.test(text)){
                return `font-size:var(--col-text-font);`;
            }
        },

        // 修改区域名称，行名称，列名称
        changeLayoutData(e, type,otherParams) {
            // 预览模式不可编辑
            if(this.isPreview){ return false; }
            
            let { value } = e.target;
            let layout_id = this.currLayoutData.area_id;
            let data = { [type]: value, layout_id };
            otherParams && (data = Object.assign(data,otherParams));
            // 修改区域名称
            if(type == 'area_name'){
                this.$request.post({ url: "createUpdateLayout", data }).then(res => {})
            // 修改行与列的名称
            }else{
                this.$request.post({url: 'saveSeatLayout',data}).then(res => {})
            }
        },

        // 右键与左键的点击事件
        handleClickSeatEvent(e, type, layout_id, row_id, desk_id, seat_id) {
            // 预览模式不可编辑
            if(this.isPreview){ return false; }
            
            let layout_index = e.target.getAttribute('layout-index');
            let row_index = e.target.getAttribute('row-index');
            let col_index = e.target.getAttribute('col-index');
            let seat_index = e.target.getAttribute('seat-index');
            let is_valid = e.target.getAttribute('is-valid');
            // 索引为更新layoutData数据做准备
            let layoutIndexParams = {layout_index,row_index,col_index,seat_index};
            // 参数ids集合，为请求做准备
            let ids = {layout_id, row_id, desk_id, seat_id};
            
            // 右键事件
            if(type == 'contextmenu'){
                this.contextMenuRef?.show(e, layoutIndexParams, null, ids);
            }

            // 点击事件
            if(type == 'click' && is_valid == 1){
                this.contextMenuRef?.show(e, layoutIndexParams, null, ids,'add');
            }
        },
        
        // 座位搜索
        setSelectionEl(seat_item) {
            let { name,person_id } = seat_item.person || {};
            // 是否在搜索时显示其他人员
            let { is_show_other } = this.meetingInfo;
            // 通过url筛选的参数
            let { search_name,person_id:user_id } = this.$route.query;
            // 1 悬停 2url搜人 3通过name
            if(person_id && (person_id == this.high_person_id || person_id == user_id || (name && search_name && name.indexOf(search_name) != -1))){
                
                // 判断是否为本页面的悬停展示效果，如果是悬停则需要定位去找人，否则查询页面因缩放已经最小了，所以取消定位
                if(this.high_person_id){
                    this.$nextTick(() => {
                        const domEl = this.$refs[`person-id-${person_id}`];
                        domEl && domEl[0].scrollIntoView({
                            behavior: "auto",
                            block: "center",
                            inline: "nearest"
                        });
                        let timer = setTimeout(() => {
                            clearTimeout(timer);
                            if (domEl && window.scrollTo) {
                                let dropElem = document.getElementsByClassName('zoom-el-box')[0];
                                let scrollLeft = dropElem && dropElem.scrollLeft;
                                let scrolltop = dropElem && dropElem.scrollTop;
                                if (scrollLeft > 0) {
                                    dropElem.scrollTo(scrollLeft + 100, scrolltop)
                                }
                            }
                        }, 1000)
                    })
                }

                return 'selection-highlight';
            }

            if(is_show_other != 1 && (search_name || user_id)){
                return 'filter-blur';
            }
           
        }
    },

    created(){
    },
    mounted() {
        // this.isMaxParentArea();
    },
}